module.exports = __webpack_public_path__ + "img/stop-audio.ee3f347.svg";